import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CommentReducer } from '.';
import { CommentState } from './comment.reducer';
import { CommentDto, SupportedAggregateTypes } from '../../models/comment.model';

export const getCommentState = createFeatureSelector<CommentState>('rsComments');

/**
 *
 */
const getTotalCountsMap = createSelector(getCommentState, CommentReducer.totalCounts);

/**
 *
 * @param aggregateType
 * @param aggregateId
 * @returns
 */
export const getTotalCount = (aggregateType: SupportedAggregateTypes, aggregateId: string) =>
  createSelector(getTotalCountsMap, (totalCounts: Map<string, number>) => {
    const aggregate: string = CommentReducer.getReferencedAggregateIdentifier(aggregateType, aggregateId);
    if (!totalCounts[aggregate]) return 0;
    return totalCounts[aggregate];
  });

/**
 *
 */
const getResultsMap = createSelector(getCommentState, CommentReducer.results);

/**
 *
 * @param aggregateType
 * @param aggregateId
 * @returns
 */
export const getResults = (aggregateType: SupportedAggregateTypes, aggregateId: string) =>
  createSelector(getResultsMap, (results: Map<string, CommentDto[]>) => {
    const aggregate: string = CommentReducer.getReferencedAggregateIdentifier(aggregateType, aggregateId);
    if (!results[aggregate]) return [];
    return results[aggregate];
  });

/**
 *
 */
const getLoadingMap = createSelector(getCommentState, CommentReducer.loading);

/**
 *
 * @param aggregateType
 * @param aggregateId
 * @returns
 */
export const getLoading = (aggregateType: SupportedAggregateTypes, aggregateId: string) =>
  createSelector(getLoadingMap, (loading: Map<string, boolean>) => {
    const aggregate: string = CommentReducer.getReferencedAggregateIdentifier(aggregateType, aggregateId);
    if (!loading[aggregate]) return false;
    return loading[aggregate];
  });
